import { useEffect, useState } from 'react';
import clsx from 'clsx';

import { Media } from '@atom/types/media';
import { WorkOrderAssetTreeType } from '@atom/types/work';
import api from '@atom/utilities/api';
import attributeDisplayUtility from '@atom/utilities/attributeDisplayUtility';
import { MEDIA_ENDPOINT } from '@atom/utilities/endpoints';

import PhotoTile from './PhotoTile';

import classes from '../workOrderDetailPdfReport.module.css';

interface Props {
  workOrderAsset: WorkOrderAssetTreeType;
  workOrderId: string;
  setOtherPhotosLoading: (currentLoading: { [id: string]: boolean }) => void;
}

const AssetAssessment = ({
  workOrderAsset,
  workOrderId,
  setOtherPhotosLoading,
}: Props) => {
  const [photos, setPhotos] = useState<Media[]>([]);

  useEffect(() => {
    const getMedia = async () => {
      const data = {
        subjectTypes: 'workOrderAsset',
        parentSubjectId: workOrderId,
        subjectIds: workOrderAsset.id,
      };
      const response = await api.get(MEDIA_ENDPOINT, data);

      setPhotos(response.data);
      // @ts-ignore
      setOtherPhotosLoading(currentLoading => ({
        ...currentLoading,
        attributeGroupAssessment: false,
      }));
    };
    getMedia();
  }, []);

  const getSubheader = () => {
    const attributeGroup = workOrderAsset.attributeGroups.filter(
      group => group.name === 'Assessment',
    );

    const attributeGroupIds = attributeGroup[0]?.attributes
      ? attributeGroup[0]?.attributes
      : [];

    return attributeGroupIds.map(key => {
      return (
        workOrderAsset.attributes[key] && (
          <th
            className={clsx(
              classes.tableHeaderCell,
              workOrderAsset.attributes[key].name === 'Comment' &&
                classes.comment,
            )}
          >
            {workOrderAsset.attributes[key].name}
          </th>
        )
      );
    });
  };

  const getValues = () => {
    const attributeGroup = workOrderAsset.attributeGroups.filter(
      group => group.name === 'Assessment',
    );

    const attributeGroupIds = attributeGroup[0]?.attributes
      ? attributeGroup[0]?.attributes
      : [];

    return attributeGroupIds.map(
      key =>
        workOrderAsset.attributes[key] && (
          <td>
            {attributeDisplayUtility.display(
              workOrderAsset.attributes[key].value,
              workOrderAsset.attributes[key].dataType,
              workOrderAsset.attributes[key].unit,
              !!workOrderAsset.attributes[key].changeId,
              workOrderAsset.attributes[key].newValue,
            )}
          </td>
        ),
    );
  };

  return (
    <div className={classes.tableWrapper}>
      <table>
        <tbody>
          <tr className={classes.tableSubheader}>{getSubheader()}</tr>
          <tr className={classes.tableValue}>{getValues()}</tr>
        </tbody>
      </table>
      <div>
        {!!photos.length && (
          <PhotoTile
            photos={photos}
            title={workOrderAsset.name}
            elements={[]}
            id={workOrderAsset.id}
            setOtherPhotosLoading={setOtherPhotosLoading}
          />
        )}
      </div>
    </div>
  );
};

export default AssetAssessment;
